import { useAnalytics } from '@/app/context/AnalyticsContext/useAnalytics';
import { useAuth } from '@/app/context/AuthContext/useAuth';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import Link from 'next/link';
import Image from 'next/image';
import React from 'react';
import appleImage from 'public/apple.jpg';

const benefits = [
  'Flashcards',
  'Quiz Questions',
  'Practice Tests',
  'Study Guides',
  'Spaced Repetition',
  'and more...'
];

export default function BetaProgramCallout() {
  const { showAuth, user } = useAuth();
  const { trackEvent, analyticsInstance } = useAnalytics();

  const onSignupClick = () => {
    trackEvent(analyticsInstance, 'get_started_click_sign_up');
    showAuth(true);
  };

  return (
    <div className="relative isolate mb-32 mt-32 sm:mt-40">
      <div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="mx-auto flex max-w-2xl flex-col gap-16 bg-white/5 px-6 py-16 ring-1 ring-white/10 sm:rounded-3xl sm:p-8 lg:mx-0 lg:max-w-none lg:flex-row lg:items-center lg:py-20 xl:gap-x-20 xl:px-20">
          <Image
            alt=""
            src={appleImage}
            className="h-96 w-full flex-none rounded-2xl object-cover shadow-xl lg:aspect-square lg:h-auto lg:max-w-sm"
          />
          <div className="w-full flex-auto">
            <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
              Get started for free
            </h2>
            <p className="mt-6 text-lg leading-8 text-gray-300">
              Create a free limbiks account and see how Limbiks can elevate your
              study routine.
            </p>
            <ul
              role="list"
              className="mt-10 grid grid-cols-1 gap-x-8 gap-y-3 text-base leading-7 text-white sm:grid-cols-2"
            >
              {benefits.map((benefit) => (
                <li key={benefit} className="flex gap-x-3">
                  <CheckCircleIcon
                    aria-hidden="true"
                    className="h-7 w-5 flex-none"
                  />
                  {benefit}
                </li>
              ))}
            </ul>
            <div className="mt-10 flex items-center gap-7">
              <button
                onClick={onSignupClick}
                className="focus:shadow-outline mx-auto mt-4 transform rounded-full bg-primary px-8 py-4 font-bold text-base-content shadow transition duration-300 ease-in-out hover:scale-105 hover:underline focus:outline-none lg:mx-0 lg:mt-0"
              >
                Sign Up
              </button>
              <Link
                href="/"
                className="mt-4 text-sm font-semibold leading-6 text-white lg:mt-0"
              >
                Learn more<span aria-hidden="true">→</span>
              </Link>
              <div className="flex-1 lg:hidden"></div>
            </div>
          </div>
        </div>
      </div>
      <div
        aria-hidden="true"
        className="absolute inset-x-0 -top-16 -z-10 flex transform-gpu justify-center overflow-hidden blur-3xl"
      >
        <div
          style={{
            clipPath:
              'polygon(73.6% 51.7%, 91.7% 11.8%, 100% 46.4%, 97.4% 82.2%, 92.5% 84.9%, 75.7% 64%, 55.3% 47.5%, 46.5% 49.4%, 45% 62.9%, 50.3% 87.2%, 21.3% 64.1%, 0.1% 100%, 5.4% 51.1%, 21.4% 63.9%, 58.9% 0.2%, 73.6% 51.7%)'
          }}
          className="aspect-[1318/752] w-[82.375rem] flex-none bg-gradient-to-r from-[#80caff] to-[#4f46e5] opacity-25"
        />
      </div>
    </div>
  );
}
